import { apolloClient } from 'app/hocs/with-apollo'
import { LOGOUT } from './graphql'
import { API_V2 } from 'constants/apollo'

class AuthService {
  constructor() {
    this.role = null
  }

  setCredentials({ role }) {
    if (role) {
      this.role = role
      localStorage.setItem('role', this.role)
    }
  }

  async removeCredentials() {
    const success = await apolloClient
      .mutate({
        mutation: LOGOUT,
        context: {
          clientName: API_V2,
        },
      })
      .then(res => {
        if (res.data?.logout?.success) {
          return true
        }

        return false
      })
      .catch(() => false)

    console.log('success', success)

    if (success) {
      this.role = null
      localStorage.removeItem('role')
    }

    return success
  }

  getRole() {
    this.role = localStorage.getItem('role') || null
  }
}

export default new AuthService()
